; (function ($, window, document, undefined) {

    var name = 'customRatingInput';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customRatingInput.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();

            for (let i = 0; i < this.options.total; i++) {
                this.$element.append(`<a href="#">
                    <i class="fa-star"></i>
                </a>`);
            }

            this.val(this.options.default);
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('click', 'a', function () {
                plugin.$element.find('a').removeClass('active');
                $(this).prevAll('a').addBack().addClass('active');

                plugin.$element.trigger('change');
            });
        },

        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        val: function (value = null) {
            if (value && !isNaN(value)) {
                this.$element.find('a').removeClass('active');
                this.$element.find('a').slice(0, value).addClass('active');
            }

            return this.$element.find('.active').length;
        },
    });

    $.fn.customRatingInput = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customRatingInput.defaults = {
        total: 5,
        default: 1,
    };

})(jQuery, window, document);
